// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YqPf","title":"styles_title__RBp0o"};